var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm.LoadingView === false
        ? _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card-header" }, [
              _c(
                "button",
                { staticClass: "btn btn-theme", on: { click: _vm.cerrar } },
                [_vm._v("Cerrar")]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "card-header",
                class:
                  _vm.purchase.deliveryStatus === 2
                    ? "bg-warning"
                    : _vm.purchase.deliveryStatus === 1
                    ? "bg-success"
                    : "bg-danger"
              },
              [_c("h5", [_vm._v("Compra: " + _vm._s(_vm.document))])]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-3" }, [
                    _c("label", { staticClass: "font-weight-bold" }, [
                      _vm._v("Fecha")
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        _vm._s(_vm.convertDate(_vm.purchase.purchase_date))
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-3" }, [
                    _c("label", { staticClass: "font-weight-bold" }, [
                      _vm._v("Fecha de entrega")
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        _vm._s(_vm.convertDate(_vm.purchase.delivery_date))
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-3" }, [
                    _c("label", { staticClass: "font-weight-bold" }, [
                      _vm._v("Localidad")
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.place.name))])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-3" }, [
                    _c("label", { staticClass: "font-weight-bold" }, [
                      _vm._v("Proveedor")
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        _vm._s(_vm.provider.nit) +
                          " | " +
                          _vm._s(_vm.provider.company)
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-3" }, [
                    _c("label", { staticClass: "font-weight-bold" }, [
                      _vm._v("Comprador")
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.buyer.name))])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-md-3" },
                    [
                      _c("label", { staticClass: "font-weight-bold" }, [
                        _vm._v("Estado")
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      [
                        _vm.purchase.deliveryStatus === 2
                          ? _c(
                              "span",
                              { staticClass: "btn btn-warning btn-sm" },
                              [_vm._v("Pendiente")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.purchase.deliveryStatus === 1
                          ? _c(
                              "span",
                              { staticClass: "btn btn-success btn-sm" },
                              [_vm._v("Comprobado")]
                            )
                          : _vm._e()
                      ]
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "card-body" }, [
                    _c("table", { staticClass: "table table-responsive" }, [
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(_vm.purchases, function(item) {
                          return _c("tr", { key: item.id }, [
                            _c("td", [_vm._v(_vm._s(item.code))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(item.nameProduct))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(item.location))]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(_vm._s(_vm.myquantity(item.amount)))
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                [
                                  _vm.purchase.deliveryStatus == 2
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model.number",
                                            value:
                                              _vm.purchases[
                                                _vm.getIndex(
                                                  _vm.purchases,
                                                  item.id
                                                )
                                              ].arrivedAmount,
                                            expression:
                                              "purchases[getIndex(purchases, item.id)].arrivedAmount",
                                            modifiers: { number: true }
                                          }
                                        ],
                                        ref:
                                          "arrivedAmount-" +
                                          _vm.getIndex(_vm.purchases, item.id),
                                        refInFor: true,
                                        staticClass: "form-control",
                                        class: {
                                          "is-invalid":
                                            _vm.purchases[
                                              _vm.getIndex(
                                                _vm.purchases,
                                                item.id
                                              )
                                            ].error === true
                                        },
                                        attrs: { type: "number" },
                                        domProps: {
                                          value:
                                            _vm.purchases[
                                              _vm.getIndex(
                                                _vm.purchases,
                                                item.id
                                              )
                                            ].arrivedAmount
                                        },
                                        on: {
                                          blur: [
                                            function($event) {
                                              _vm.validateQuantity(
                                                _vm.getIndex(
                                                  _vm.purchases,
                                                  item.id
                                                )
                                              )
                                            },
                                            function($event) {
                                              return _vm.$forceUpdate()
                                            }
                                          ],
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.purchases[
                                                _vm.getIndex(
                                                  _vm.purchases,
                                                  item.id
                                                )
                                              ],
                                              "arrivedAmount",
                                              _vm._n($event.target.value)
                                            )
                                          }
                                        }
                                      })
                                    : _c("label", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.purchases[
                                              _vm.getIndex(
                                                _vm.purchases,
                                                item.id
                                              )
                                            ].arrivedAmount
                                          )
                                        }
                                      })
                                ]
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _vm.purchase.deliveryStatus == 2
                              ? _c(
                                  "td",
                                  [
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "btn-group mr-2",
                                          attrs: {
                                            role: "group",
                                            "aria-label": "First group"
                                          }
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              directives: [
                                                {
                                                  name: "tooltip",
                                                  rawName:
                                                    "v-tooltip.top-center",
                                                  value:
                                                    "Editar ubicación física",
                                                  expression:
                                                    "'Editar ubicación física'",
                                                  modifiers: {
                                                    "top-center": true
                                                  }
                                                }
                                              ],
                                              staticClass:
                                                "btn btn-theme btn-block",
                                              on: {
                                                click: function($event) {
                                                  return _vm.openModal2(item)
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "icon-fa icon-fa-pencil"
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "custom-control custom-checkbox mb-3"
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.purchases[
                                                        _vm.getIndex(
                                                          _vm.purchases,
                                                          item.id
                                                        )
                                                      ].status,
                                                    expression:
                                                      "purchases[getIndex(purchases, item.id)].status"
                                                  }
                                                ],
                                                staticClass: "form-check-input",
                                                attrs: { type: "checkbox" },
                                                domProps: {
                                                  checked: Array.isArray(
                                                    _vm.purchases[
                                                      _vm.getIndex(
                                                        _vm.purchases,
                                                        item.id
                                                      )
                                                    ].status
                                                  )
                                                    ? _vm._i(
                                                        _vm.purchases[
                                                          _vm.getIndex(
                                                            _vm.purchases,
                                                            item.id
                                                          )
                                                        ].status,
                                                        null
                                                      ) > -1
                                                    : _vm.purchases[
                                                        _vm.getIndex(
                                                          _vm.purchases,
                                                          item.id
                                                        )
                                                      ].status
                                                },
                                                on: {
                                                  change: [
                                                    function($event) {
                                                      var $$a =
                                                          _vm.purchases[
                                                            _vm.getIndex(
                                                              _vm.purchases,
                                                              item.id
                                                            )
                                                          ].status,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = null,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            _vm.$set(
                                                              _vm.purchases[
                                                                _vm.getIndex(
                                                                  _vm.purchases,
                                                                  item.id
                                                                )
                                                              ],
                                                              "status",
                                                              $$a.concat([$$v])
                                                            )
                                                        } else {
                                                          $$i > -1 &&
                                                            _vm.$set(
                                                              _vm.purchases[
                                                                _vm.getIndex(
                                                                  _vm.purchases,
                                                                  item.id
                                                                )
                                                              ],
                                                              "status",
                                                              $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                )
                                                            )
                                                        }
                                                      } else {
                                                        _vm.$set(
                                                          _vm.purchases[
                                                            _vm.getIndex(
                                                              _vm.purchases,
                                                              item.id
                                                            )
                                                          ],
                                                          "status",
                                                          $$c
                                                        )
                                                      }
                                                    },
                                                    _vm.verify
                                                  ]
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("label", [_vm._v("Listo")])
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ],
                                  2
                                )
                              : _vm._e()
                          ])
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("tfoot", [
                        _c("tr", [
                          _c(
                            "th",
                            {
                              staticClass: "text-right",
                              attrs: { colspan: "5" }
                            },
                            [
                              _vm.checks && _vm.purchase.deliveryStatus == 2
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-success",
                                      on: { click: _vm.openModal }
                                    },
                                    [_vm._v("Terminar entrega")]
                                  )
                                : _vm._e()
                            ]
                          )
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.LoadingView === true
        ? _c(
            "div",
            { staticClass: "spinner-border", attrs: { role: "status" } },
            [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "sweet-modal",
        {
          ref: "activate_modal",
          attrs: { icon: "info", "hide-close-button": "", blocking: "" }
        },
        [
          _vm._v("\n    " + _vm._s(_vm.modalTitleActivate) + "\n    "),
          _c(
            "button",
            {
              staticClass: "btn btn-info",
              attrs: { slot: "button", type: "button" },
              on: {
                click: function($event) {
                  return _vm.$refs.activate_modal.close()
                }
              },
              slot: "button"
            },
            [_vm._v("No")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary ladda-button",
              attrs: {
                slot: "button",
                type: "button",
                "data-style": "expand-right"
              },
              on: {
                click: function($event) {
                  return _vm.receive()
                }
              },
              slot: "button"
            },
            [_vm._v("Si")]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "sweet-modal",
        {
          ref: "updateLocationModal",
          attrs: {
            title: _vm.updatetitle,
            "hide-close-button": "",
            blocking: ""
          }
        },
        [
          _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", [_vm._v("Ubicación")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.location,
                    expression: "location",
                    modifiers: { trim: true }
                  }
                ],
                staticClass: "form-control",
                class: { "is-invalid": _vm.$v.location.$error },
                domProps: { value: _vm.location },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.location = $event.target.value.trim()
                    },
                    function($event) {
                      return _vm.$v.location.$touch()
                    }
                  ],
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              }),
              _vm._v(" "),
              _vm.$v.location.$error
                ? _c("div", [
                    !_vm.$v.location.required
                      ? _c(
                          "span",
                          { staticClass: "help-block help-block-error" },
                          [_vm._v("El campo es requerido")]
                        )
                      : _vm._e()
                  ])
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-info",
              attrs: { slot: "button", type: "button" },
              on: { click: _vm.closeModal },
              slot: "button"
            },
            [_vm._v("No")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-primary ladda-button",
              attrs: {
                slot: "button",
                type: "button",
                "data-style": "expand-right"
              },
              on: {
                click: function($event) {
                  return _vm.updateLocation()
                }
              },
              slot: "button"
            },
            [_vm._v("Si")]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("h3", { staticClass: "page-title" }, [_vm._v("Ver entrega")]),
      _vm._v(" "),
      _c("ol", { staticClass: "breadcrumb" }, [
        _c("li", { staticClass: "breadcrumb-item" }, [
          _c("a", { attrs: { href: "#" } }, [_vm._v("Bodega")])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "breadcrumb-item active" }, [_vm._v("Entrega")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Código")]),
        _vm._v(" "),
        _c("th", [_vm._v("Producto")]),
        _vm._v(" "),
        _c("th", [_vm._v("Ubicacíon")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cantidad solicitada")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cantidad que llegó")]),
        _vm._v(" "),
        _c("th", [_vm._v("Opciones")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04e3c7c2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04e3c7c2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/admin/cellar/deliveryReceived.vue
// module id = 726
// module chunks = 0